module.exports = __webpack_public_path__ + "static/media/anfahrt_icon.321cc8e2.svg";